import { AppModule } from "@/shared/app";
import { managementApp } from "../app";

export const decisionModule: AppModule = {
  app: managementApp,
  route: "decyzje",
  title: "Decyzje",
  iconClass: "fas fa-clipboard-check fa-fw",
};
